<template>
  <div class="my-[21px] flex min-h-[200px] flex-col bg-white shadow-[0_1px_5px_rgba(0,0,0,0.3)] sm:flex-row">
    <div class="relative h-[200px] sm:h-auto sm:w-[200px] sm:flex-none">
      <div
        data-testid="collection-card-image"
        class="absolute inset-0 bg-cover bg-center bg-no-repeat"
        :style="{ backgroundImage: `url('${imageKitUrl}')` }"
      />
    </div>
    <div class="min-w-0 break-words py-3.5 pl-[21px] pr-3.5">
      <span class="font-bold text-gray-700">{{ label }}</span>
      <component :is="`h${headingLevel}`" class="mb-3 mt-1.5 text-display-sm font-medium leading-[1.1]">{{ title }}</component>

      <div>
        <slot name="description" />
      </div>

      <div class="mt-[21px]">
        <slot name="bar" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { urlFromAWSUrl } from '@/imagekit/imageurl_from_aws_url'

const props = withDefaults(defineProps<{
  label: string
  title: string
  imageUrl: string
  headingLevel?: 2 | 3
}>(), { headingLevel: 3 })

const imageKitUrl = computed(() => urlFromAWSUrl(props.imageUrl, [{ width: 200 }]))
</script>
